import {
    type UpdateDriveFileResponseType,
    type UpdateDriveFileRequestType
} from "./type";
import {
    request
} from "../request";

const UpdateDriveFile = async (params: UpdateDriveFileRequestType): Promise<UpdateDriveFileResponseType> => {
    return await request<UpdateDriveFileResponseType>("/drive/updateDriveFile", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default UpdateDriveFile;
